import styled from 'styled-components';

export const InputField = (props) => {
  const {
    type = 'text',
    inputmode = 'numeric',
    name,
    label,
    values,
    onChange,
    length,
    errorText,
    error
  } = props;

  return (
    <CustomInput error={values.submitCount > 0 && error}>
      <p>{label}* :</p>
      <div>
        <input
          maxLength={length}
          value={values[name]}
          onChange={(event) => onChange(event)}
          type={type}
          name={name}
          inputMode={inputmode}
          pattern="[0-9]+"
        />
        <span style={{ height: 0 }}>
          {error && values.submitCount > 0 ? errorText : ''}
        </span>
      </div>
    </CustomInput>
  );
};

const CustomInput = styled.div`
  direction: ltr;
  min-height: 114px;
  @media screen and (min-width: 1024px) {
    position: relative;
    display: grid;
    grid-template-columns: 50% 50%;
    place-content: center;
    p {
      margin: auto 0 !important;
      font-size: 24px !important;
      font-weight: 400 !important;
      color: #4e4e4e !important;
    }

    span {
      font-size: 16px !important;
      margin-top: 3px !important;
    }

    input {
      width: 336px !important;
      height: 64px !important;
      font-size: 24px !important;
      background: #ffffff !important;
    }

    input:hover {
      border: 1px solid #6f4d9f99;
    }
  }

  input {
    height: 48px;
    text-align: center;
    outline: none;
    width: 100%;
    z-index: 0;
    border-radius: 16px;
    background: #f5f5f5;
    border: 1px solid #ffffff;
    border: ${({ error }) =>
      error ? '1px solid #D81D5D' : '1px solid #ffffff'};
    box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.16);
    color: #6f4d9f;
    font-size: 18px;
    font-family: 'dana-bold';
  }

  input:focus {
    border: 1px solid #6f4d9f99;
  }

  p {
    text-align: left;
    color: #707070;
    font-size: 16px;
    font-weight: 400;
    margin-bottom: 14px;
  }

  span {
    text-align: left;
    color: #d81d5d;
    font-size: 12px;
  }
`;
